"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishersApi = exports.PublishersApiFactory = exports.PublishersApiFp = exports.PublishersApiAxiosParamCreator = exports.ConfigurationsApi = exports.ConfigurationsApiFactory = exports.ConfigurationsApiFp = exports.ConfigurationsApiAxiosParamCreator = exports.UpdateFeedbackSettingsPurposeEnum = exports.UpdateFeedbackSettingsAttemptEnum = exports.PermissionType = exports.ModelConfigurationDtoPhoneSetEnum = exports.LanguageCode = exports.FeedbackSettingsDtoPurposeEnum = exports.FeedbackSettingsDtoAttemptEnum = void 0;
const axios_1 = require("axios");
const common_1 = require("./common");
const base_1 = require("./base");
exports.FeedbackSettingsDtoAttemptEnum = {
    immediate: 'immediate',
    none: 'none',
    delayed: 'delayed'
};
exports.FeedbackSettingsDtoPurposeEnum = {
    reading: 'reading',
    pronunciation: 'pronunciation'
};
exports.LanguageCode = {
    ar_idn: 'ar-idn',
    de: 'de',
    en: 'en',
    nl: 'nl',
    zh: 'zh',
    fr: 'fr',
    es: 'es'
};
exports.ModelConfigurationDtoPhoneSetEnum = {
    cmu69: 'cmu69',
    novo_nl37: 'novo-nl37',
    novo_cmn111: 'novo-cmn111',
    novo_fr37: 'novo-fr37',
    novo_fr_nl61: 'novo-fr-nl61',
    novo_de45: 'novo-de45',
    novo_es27: 'novo-es27',
    novo_ar38: 'novo-ar38',
    novo_ar37: 'novo-ar37'
};
exports.PermissionType = {
    attempt_read_result: 'attempt_read_result',
    attempt_read_audio: 'attempt_read_audio',
    attempt_read_group_result: 'attempt_read_group_result',
    attempt_read_group_audio: 'attempt_read_group_audio',
    attempt_edit: 'attempt_edit',
    attempt_delete: 'attempt_delete',
    attempt_maintenance: 'attempt_maintenance',
    exercise_edit: 'exercise_edit',
    exercise_delete: 'exercise_delete',
    exercise_maintenance: 'exercise_maintenance',
    publisher_edit: 'publisher_edit',
    publisher_read: 'publisher_read',
    publisher_maintenance: 'publisher_maintenance',
    publisher_configuration_read: 'publisher_configuration_read',
    publisher_configuration_edit: 'publisher_configuration_edit',
    pronunciation_edit: 'pronunciation_edit'
};
exports.UpdateFeedbackSettingsAttemptEnum = {
    immediate: 'immediate',
    none: 'none',
    delayed: 'delayed'
};
exports.UpdateFeedbackSettingsPurposeEnum = {
    reading: 'reading',
    pronunciation: 'pronunciation'
};
const ConfigurationsApiAxiosParamCreator = function (configuration) {
    return {
        createConfiguration: async (configurationCreateDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('createConfiguration', 'configurationCreateDtoV1', configurationCreateDtoV1);
            const localVarPath = `/configurations`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(configurationCreateDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteConfiguration: async (id, options = {}) => {
            (0, common_1.assertParamExists)('deleteConfiguration', 'id', id);
            const localVarPath = `/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        editConfiguration: async (id, configurationDtoV1, options = {}) => {
            (0, common_1.assertParamExists)('editConfiguration', 'id', id);
            (0, common_1.assertParamExists)('editConfiguration', 'configurationDtoV1', configurationDtoV1);
            const localVarPath = `/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(configurationDtoV1, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        findAllConfigurations: async (options = {}) => {
            const localVarPath = `/configurations`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        findConfiguration: async (id, options = {}) => {
            (0, common_1.assertParamExists)('findConfiguration', 'id', id);
            const localVarPath = `/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ConfigurationsApiAxiosParamCreator = ConfigurationsApiAxiosParamCreator;
const ConfigurationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConfigurationsApiAxiosParamCreator)(configuration);
    return {
        async createConfiguration(configurationCreateDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConfiguration(configurationCreateDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deleteConfiguration(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConfiguration(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async editConfiguration(id, configurationDtoV1, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editConfiguration(id, configurationDtoV1, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async findAllConfigurations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllConfigurations(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async findConfiguration(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findConfiguration(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ConfigurationsApiFp = ConfigurationsApiFp;
const ConfigurationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConfigurationsApiFp)(configuration);
    return {
        createConfiguration(configurationCreateDtoV1, options) {
            return localVarFp.createConfiguration(configurationCreateDtoV1, options).then((request) => request(axios, basePath));
        },
        deleteConfiguration(id, options) {
            return localVarFp.deleteConfiguration(id, options).then((request) => request(axios, basePath));
        },
        editConfiguration(id, configurationDtoV1, options) {
            return localVarFp.editConfiguration(id, configurationDtoV1, options).then((request) => request(axios, basePath));
        },
        findAllConfigurations(options) {
            return localVarFp.findAllConfigurations(options).then((request) => request(axios, basePath));
        },
        findConfiguration(id, options) {
            return localVarFp.findConfiguration(id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConfigurationsApiFactory = ConfigurationsApiFactory;
class ConfigurationsApi extends base_1.BaseAPI {
    createConfiguration(configurationCreateDtoV1, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).createConfiguration(configurationCreateDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    deleteConfiguration(id, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).deleteConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }
    editConfiguration(id, configurationDtoV1, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).editConfiguration(id, configurationDtoV1, options).then((request) => request(this.axios, this.basePath));
    }
    findAllConfigurations(options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).findAllConfigurations(options).then((request) => request(this.axios, this.basePath));
    }
    findConfiguration(id, options) {
        return (0, exports.ConfigurationsApiFp)(this.configuration).findConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConfigurationsApi = ConfigurationsApi;
const PublishersApiAxiosParamCreator = function (configuration) {
    return {
        addPublisher: async (createPublisherDto, options = {}) => {
            (0, common_1.assertParamExists)('addPublisher', 'createPublisherDto', createPublisherDto);
            const localVarPath = `/publishers`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPublisherDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addUsageData: async (id, requestBody, options = {}) => {
            (0, common_1.assertParamExists)('addUsageData', 'id', id);
            (0, common_1.assertParamExists)('addUsageData', 'requestBody', requestBody);
            const localVarPath = `/publishers/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deletePublisher: async (id, options = {}) => {
            (0, common_1.assertParamExists)('deletePublisher', 'id', id);
            const localVarPath = `/publishers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        findAllPublishers: async (options = {}) => {
            const localVarPath = `/publishers`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAndValidatePublisher: async (id, apiKey, anonymous, options = {}) => {
            (0, common_1.assertParamExists)('getAndValidatePublisher', 'id', id);
            const localVarPath = `/publishers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apiKey !== undefined) {
                localVarQueryParameter['apiKey'] = apiKey;
            }
            if (anonymous !== undefined) {
                localVarQueryParameter['anonymous'] = anonymous;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPublisherOAuthSettings: async (id, options = {}) => {
            (0, common_1.assertParamExists)('getPublisherOAuthSettings', 'id', id);
            const localVarPath = `/publishers/{id}/oauth`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPublisherUsageSummary: async (id, from, to, options = {}) => {
            (0, common_1.assertParamExists)('getPublisherUsageSummary', 'id', id);
            (0, common_1.assertParamExists)('getPublisherUsageSummary', 'from', from);
            (0, common_1.assertParamExists)('getPublisherUsageSummary', 'to', to);
            const localVarPath = `/publishers/{id}/usage`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUsageSummary: async (from, to, options = {}) => {
            (0, common_1.assertParamExists)('getUsageSummary', 'from', from);
            (0, common_1.assertParamExists)('getUsageSummary', 'to', to);
            const localVarPath = `/publishers/usage`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        requestAccount: async (requestAccountDto, options = {}) => {
            (0, common_1.assertParamExists)('requestAccount', 'requestAccountDto', requestAccountDto);
            const localVarPath = `/publishers/requestAccount`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestAccountDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePublisher: async (id, updatePublisherDto, apiKey, options = {}) => {
            (0, common_1.assertParamExists)('updatePublisher', 'id', id);
            (0, common_1.assertParamExists)('updatePublisher', 'updatePublisherDto', updatePublisherDto);
            const localVarPath = `/publishers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (apiKey !== undefined) {
                localVarQueryParameter['apiKey'] = apiKey;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatePublisherDto, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PublishersApiAxiosParamCreator = PublishersApiAxiosParamCreator;
const PublishersApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PublishersApiAxiosParamCreator)(configuration);
    return {
        async addPublisher(createPublisherDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPublisher(createPublisherDto, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async addUsageData(id, requestBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUsageData(id, requestBody, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async deletePublisher(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePublisher(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async findAllPublishers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllPublishers(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getAndValidatePublisher(id, apiKey, anonymous, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndValidatePublisher(id, apiKey, anonymous, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPublisherOAuthSettings(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublisherOAuthSettings(id, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getPublisherUsageSummary(id, from, to, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublisherUsageSummary(id, from, to, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async getUsageSummary(from, to, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageSummary(from, to, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async requestAccount(requestAccountDto, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccount(requestAccountDto, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async updatePublisher(id, updatePublisherDto, apiKey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePublisher(id, updatePublisherDto, apiKey, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.PublishersApiFp = PublishersApiFp;
const PublishersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PublishersApiFp)(configuration);
    return {
        addPublisher(createPublisherDto, options) {
            return localVarFp.addPublisher(createPublisherDto, options).then((request) => request(axios, basePath));
        },
        addUsageData(id, requestBody, options) {
            return localVarFp.addUsageData(id, requestBody, options).then((request) => request(axios, basePath));
        },
        deletePublisher(id, options) {
            return localVarFp.deletePublisher(id, options).then((request) => request(axios, basePath));
        },
        findAllPublishers(options) {
            return localVarFp.findAllPublishers(options).then((request) => request(axios, basePath));
        },
        getAndValidatePublisher(id, apiKey, anonymous, options) {
            return localVarFp.getAndValidatePublisher(id, apiKey, anonymous, options).then((request) => request(axios, basePath));
        },
        getPublisherOAuthSettings(id, options) {
            return localVarFp.getPublisherOAuthSettings(id, options).then((request) => request(axios, basePath));
        },
        getPublisherUsageSummary(id, from, to, options) {
            return localVarFp.getPublisherUsageSummary(id, from, to, options).then((request) => request(axios, basePath));
        },
        getUsageSummary(from, to, options) {
            return localVarFp.getUsageSummary(from, to, options).then((request) => request(axios, basePath));
        },
        requestAccount(requestAccountDto, options) {
            return localVarFp.requestAccount(requestAccountDto, options).then((request) => request(axios, basePath));
        },
        updatePublisher(id, updatePublisherDto, apiKey, options) {
            return localVarFp.updatePublisher(id, updatePublisherDto, apiKey, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PublishersApiFactory = PublishersApiFactory;
class PublishersApi extends base_1.BaseAPI {
    addPublisher(createPublisherDto, options) {
        return (0, exports.PublishersApiFp)(this.configuration).addPublisher(createPublisherDto, options).then((request) => request(this.axios, this.basePath));
    }
    addUsageData(id, requestBody, options) {
        return (0, exports.PublishersApiFp)(this.configuration).addUsageData(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    deletePublisher(id, options) {
        return (0, exports.PublishersApiFp)(this.configuration).deletePublisher(id, options).then((request) => request(this.axios, this.basePath));
    }
    findAllPublishers(options) {
        return (0, exports.PublishersApiFp)(this.configuration).findAllPublishers(options).then((request) => request(this.axios, this.basePath));
    }
    getAndValidatePublisher(id, apiKey, anonymous, options) {
        return (0, exports.PublishersApiFp)(this.configuration).getAndValidatePublisher(id, apiKey, anonymous, options).then((request) => request(this.axios, this.basePath));
    }
    getPublisherOAuthSettings(id, options) {
        return (0, exports.PublishersApiFp)(this.configuration).getPublisherOAuthSettings(id, options).then((request) => request(this.axios, this.basePath));
    }
    getPublisherUsageSummary(id, from, to, options) {
        return (0, exports.PublishersApiFp)(this.configuration).getPublisherUsageSummary(id, from, to, options).then((request) => request(this.axios, this.basePath));
    }
    getUsageSummary(from, to, options) {
        return (0, exports.PublishersApiFp)(this.configuration).getUsageSummary(from, to, options).then((request) => request(this.axios, this.basePath));
    }
    requestAccount(requestAccountDto, options) {
        return (0, exports.PublishersApiFp)(this.configuration).requestAccount(requestAccountDto, options).then((request) => request(this.axios, this.basePath));
    }
    updatePublisher(id, updatePublisherDto, apiKey, options) {
        return (0, exports.PublishersApiFp)(this.configuration).updatePublisher(id, updatePublisherDto, apiKey, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PublishersApi = PublishersApi;
//# sourceMappingURL=api.js.map